export function formatAssetUrl(url) {
	if (!url) {
		return "";
	}

	var value = String(url).trim();

	if (!value) {
		return "";
	}
	if (/^(https?:)?\/\//i.test(value) || /^(data|blob):/i.test(value)) {
		return value;
	}

	var baseUrl = (process.env.VUE_APP_BASE_API || "").replace(/\/+$/, "");

	if (!baseUrl) {
		return value;
	}

	return baseUrl + "/" + value.replace(/^\/+/, "");
}
